module.exports = __webpack_public_path__ + "static/media/a3.f4266977.jpg";